import { Client } from '../../types/menu';
import { useCallback, useMemo } from 'react';
import collect from 'collect.js';
import React from 'react';
import Modifier from './Modifier';
import { Server } from '../../types/basket';
import { WithClassname } from '../../types';

export type Props = WithClassname & {
  data: Client.ModifierGroup;
  selectedModifiers: Server.OrderLineItemModifier[];
  toggleModifier: (modifierGroup: Client.ModifierGroup, modifier: Client.Modifier) => void;
};

export default function ModifierGroup({
  data,
  selectedModifiers,
  toggleModifier,
  className,
}: Props) {
  const isRequired = useMemo(
    () => data.is_required && collect(data.modifiers).where('is_available', true).isNotEmpty(),
    [data.is_required, data.modifiers],
  );

  const isModifierSelected = useCallback(
    (modifierId: number) =>
      !!collect(selectedModifiers).first(
        (item) => item.modifier_group_id === data.id && item.modifier_id === modifierId,
      ),
    [data.id, selectedModifiers],
  );

  return (
    <div id={`modifier-group-${data.id}`} className={className}>
      <div className="bg-gray-500 px-lg py-xs">
        <div className="flex flex-row items-center">
          <h6 className="mr-sm">{data.name}</h6>
          {isRequired && <p className="text-gray-700 text-sm">Required</p>}
        </div>
        {data.max_count > 1 && (
          <p className="text-gray-700 mt-2xs text-sm">Select up to {data.max_count}</p>
        )}
      </div>
      <div className="lg:px-lg px-md pt-md">
        {data.modifiers.map((item) => (
          <Modifier
            data={item}
            isSelected={isModifierSelected(item.id)}
            isSingleSelect={data.max_count === 1}
            toggle={(modifier) => toggleModifier(data, modifier)}
            className="mt-sm first:mt-0"
            key={`modifier-group-${data.id}-modifier-${item.id}`}
          />
        ))}
      </div>
    </div>
  );
}
